import ContentContainer from '@fragments/Setting/ContentContainer';
import Device from '@fragments/Setting/Device';
import SettingCheckModal from '@fragments/Setting/Modal';
import { useGetPath } from '@hooks/interview/useGetPath';
import { isSpeakerChecked } from '@stores/selectors/device';
import { useAtomValue } from 'jotai';
import type { FC } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { EnterButton } from './style';

const Content: FC = () => {
  const deviceCheck = useAtomValue(isSpeakerChecked);
  const { rootPath } = useGetPath();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);

  const handleClickConfirm = async () => {
    if (!deviceCheck) return setOpenModal(true);
    navigate(rootPath.WAITING);
  };

  const handleClickModalCancel = () => {
    setOpenModal(false);
  };

  const handleClickModalConfirm = () => {
    navigate(rootPath.WAITING);
  };

  return (
    <ContentContainer>
      <Device />

      <EnterButton onClick={handleClickConfirm} disabled={!deviceCheck}>
        면접실 입장
      </EnterButton>
      <SettingCheckModal
        onClickConfirm={handleClickModalConfirm}
        onClickCancel={handleClickModalCancel}
        open={openModal}
      />
    </ContentContainer>
  );
};

export default Content;
